import { createContext } from 'react';

/** Holds every CollapsibleSection below open while true (e.g. while a field filter is set). */
export const CollapsibleForceOpenContext = createContext(false);
